import { render, staticRenderFns } from "./benefitLifeManageList.vue?vue&type=template&id=213dbcd2&scoped=true"
import script from "./benefitLifeManageList.vue?vue&type=script&lang=js"
export * from "./benefitLifeManageList.vue?vue&type=script&lang=js"
import style0 from "./benefitLifeManageList.vue?vue&type=style&index=0&id=213dbcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213dbcd2",
  null
  
)

export default component.exports